import { useEffect, useState } from "react";
import { FaArrowRight } from "react-icons/fa6";
import { FiInfo } from "react-icons/fi";
import * as A from "./style";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../Redux/store";
import { fetchMemberShipDetails } from "../../Redux/slices/settingSlice";
import CommonLoader from "../../Components/CommonLoader";

const Activity = () => {
  const dispatch: AppDispatch = useDispatch();
  const settings = useSelector((state: RootState) => state.setting);
  const user = useSelector((state: RootState) => state.user);
  const [showDiscoveryInfo, setShowDiscoveryInfo] = useState(false);

  useEffect(() => {
    if (user.id) {
      dispatch(fetchMemberShipDetails(user.id));
    }
  }, [dispatch, user.id]);

  if (settings.loading)
    return (
      <A.Activity>
        <h1 className="text-white text-center font-noto font-semibold">
          Activity
        </h1>
        <CommonLoader message="fetching activity details..." />
      </A.Activity>
    );

  return (
    <A.Activity>
      <h1 className="text-white text-center font-noto font-semibold">
        Activity
      </h1>

      <A.Section>
        <div>
          <A.SectionTitle>Membership</A.SectionTitle>
          <A.StatRow>
            <span>Total Membership</span>
            <span>
              {settings?.memberIncomeStatistic?.totalActiveSubscribers ?? 0}
            </span>
          </A.StatRow>

          <A.SettingsLink as={Link} to="/membership/pricing">
            <span>Change Membership Settings</span>
            <FaArrowRight />
          </A.SettingsLink>
        </div>
      </A.Section>

      <A.Section>
        <div>
          <A.SectionTitle>Discovery</A.SectionTitle>
          <A.StatRow>
            <A.LabelWithInfo>
              <span>Profile Views (Last 30 Days)</span>
              <A.InfoButton
                type="button"
                aria-label="Profile views info"
                onClick={() => setShowDiscoveryInfo((visible) => !visible)}
              >
                <FiInfo />
              </A.InfoButton>
            </A.LabelWithInfo>
            <span>{settings?.memberDiscoveryStatistic?.profileViewsLast30Days ?? 0}</span>
          </A.StatRow>
          {showDiscoveryInfo && (
            <A.InfoBox>
              <p>
                Profile views from the rolling last 30 days. Existing members are excluded from this count.
              </p>
              <A.InfoDismissButton
                type="button"
                onClick={() => setShowDiscoveryInfo(false)}
              >
                Got it
              </A.InfoDismissButton>
            </A.InfoBox>
          )}
        </div>
      </A.Section>

      <A.Section>
        <div>
          <A.SectionTitle>Earnings</A.SectionTitle>
          <div className="flex flex-col gap-2">
            <A.StatRow>
              <span>Current Earnings</span>
              <span>
                &#8377;
                {settings?.memberIncomeStatistic?.availableForPayout > 0
                  ? Number(settings?.memberIncomeStatistic?.availableForPayout) / 100
                  : 0}
              </span>
            </A.StatRow>
          </div>
        </div>
      </A.Section>

      <A.Section>
        <div>
          <A.SectionTitle>Post Interaction</A.SectionTitle>
          <div className="flex flex-col gap-2">
            <A.StatRow>
              <span>Post Total</span>
              <span>{settings?.memberStatistic?.numberOfPosts ?? 0}</span>
            </A.StatRow>
            <A.StatRow>
              <span>Likes</span>
              <span>{settings?.memberStatistic?.totalLikes ?? 0}</span>
            </A.StatRow>
            <A.StatRow>
              <span>Comments</span>
              <span>{settings?.memberStatistic?.totalComments ?? 0}</span>
            </A.StatRow>
          </div>
        </div>
      </A.Section>
    </A.Activity>
  );
};

export default Activity;